import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100vh - 152px);
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
`

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-family: ${theme.font.comfortaa};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    margin: 14px 8px -72px 90px;
    width: 100%;
    max-width: 1284px;

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 460px;
    `}

    ${media.lessThan('small')`
      max-width: 270px;
    `}
  `}
`

export const CardContainerWhite = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1284px;
    height: auto;
    margin: 82px 8px 40px 90px;
    background-color: ${theme.colors.white};
    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    @media print {
      margin: 0 !important;
      max-width: none;
    }
  `}
`

export const CardContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1284px;
    height: auto;
    margin: 82px 8px 40px 90px;

    border-radius: ${theme.border.radius};

    ${media.lessThan('huge')`
      max-width: 87%;
    `}

    ${media.lessThan('medium')`
      max-width: 580px;
    `}

    @media print {
      margin: 0 !important;
      max-width: none;
    }
  `}
`

export const HeaderContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 63px;
    padding: 0 40px 0 7px;
    background: ${theme.colors.white};
    border-radius: 6px;
    > button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 7px 0 0;
      width: 20%;

      > svg {
        position: absolute;
        left: 25px;
      }
    }

    ${media.lessThan('medium')`
    > button {
      display: none;
    }
  `}
  `}
`

export const LinksContainer = styled.div`
  ${({ theme }) => css`
    > a {
      text-decoration: none;
      color: ${theme.colors.xgray};
      font-family: ${theme.font.comfortaa};
      font-weight: ${theme.font.xbold};
      font-size: ${theme.font.sizes.normal};
      border-right: 1px solid ${theme.colors.mainBg};
      border-bottom: 1px solid ${theme.colors.mainBg};
      padding: 15px 40px;
      transition: color ${theme.transition.default};
      margin-bottom: 10px;
      &:hover {
        color: ${theme.colors.primary};
        border-bottom: 2px solid ${theme.colors.primary};
      }
    }

    .active {
      color: ${theme.colors.primary};
      border-bottom: 2px solid ${theme.colors.primary};
    }
  `}
`

export const ActionsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-top: 50px;
    margin-bottom: 20px;
    padding: 0 24px;

    > button {
      max-width: 228px;
      position: relative;

      > svg {
        position: absolute;
        left: 16px;
        top: 14px;

        > path {
          fill: ${theme.colors.white};
        }
      }
    }

    ${media.lessThan('medium')`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      > button {
        max-width: 100%;
        margin: 0px 20px;
      }

      > div {
        margin: 18px 20px 0 20px;
      }
    `}
  `}
`

export const TableContainer = styled.div`
  padding: 24px;

  ${media.lessThan('medium')`
    padding: 24px 50px;
  `}
`

export const LeftSide = styled.div`
  margin-top: 15px;
`
export const RightSide = styled.div`
  margin-top: 15px;
  .none-service {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
`
export const PatientCard = styled.div`
  ${({ theme }) => css`
    margin-top: 15px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.cardRadius};
    width: 100%;
    padding: 20px 20px;
    border: 1px solid ${theme.colors.xxlightGray};
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
  `}
`
export const DescriptionCard = styled.div`
  ${({ theme }) => css`
    margin-top: 15px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.cardRadius};
    width: 100%;
    padding: 20px 20px;
    border: 1px solid ${theme.colors.xxlightGray};
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
  `}
`
export const TitleCard = styled.h4`
  ${({ theme }) => css`
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    display: flex;
    justify-content: space-between;
  `}
  label {
    margin-top: -4;
    &:after {
      top: 27px;
    }
  }
`
export const ActionButtonCard = styled.button`
  ${({ theme }) => css`
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    border: 1px solid ${theme.colors.primary};
    padding: 3px 7px;
    border-radius: 6px;
    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    :hover {
      background-color: ${theme.colors.primary};
      & svg,
      path {
        fill: #fff;
      }
    }
    :disabled {
      opacity: 0.4;
      color: ${theme.colors.darkGray};
      border: 1px solid ${theme.colors.darkGray};
      svg,
      path {
        fill: ${theme.colors.darkGray};
      }
    }
  `}
`
export const ActionButtonCardCancel = styled.button`
  ${({ theme }) => css`
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.xxxsmall};
    background-color: transparent;
    border: 1px solid ${theme.colors.red};
    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.15);
    padding: 3px 7px;
    border-radius: 6px;
    cursor: pointer;
    transition: ease all 200ms;
    display: flex;
    :hover {
      background-color: ${theme.colors.primary};
      & svg,
      path {
        fill: #fff;
      }
    }
    :disabled {
      opacity: 0.4;
      color: ${theme.colors.darkGray};
      border: 1px solid ${theme.colors.darkGray};
      svg,
      path {
        fill: ${theme.colors.darkGray};
      }
    }
  `}
`
export const ParagraphCard = styled.p`
  ${({ theme }) => css`
    margin-top: 15px;
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.normal};
    font-size: 0.8rem;
    color: ${theme.colors.darkGray};
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`
export const ToolButton = styled.button`
  ${({ theme }) => css`
    cursor: pointer;
    opacity: ;
    margin-top: 15px;
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.bold};
    font-size: 0.8rem;
    color: ${theme.colors.darkGray};
    background-color: transparent;
    display: flex;
    align-items: center;
    svg {
      margin-right: 5px;
    }
    :hover {
      opacity: 0.6;
    }
    :disabled {
      opacity: 0.4;
      color: ${theme.colors.darkGray};
      svg,
      path {
        fill: ${theme.colors.darkGray};
      }
    }
  `}
`

export const LabelCard = styled.span`
  ${({ theme }) => css`
    margin-top: 15px;
    width: 100%;
    display: flex;
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.normal};
    font-size: 0.8rem;
    flex-direction: column;
    label {
      color: ${theme.colors.primary};
      display: flex;
      svg {
        margin-right: 7px;
      }
    }

    p {
      margin-left: 18px;
      color: ${theme.colors.gray};
      margin-top: 3px;
      margin-bottom: 0;
    }
  `}
`
export const ToolCard = styled.div`
  ${({ theme }) => css`
    margin-top: 15px;
    background: ${theme.colors.white};
    border-radius: ${theme.border.cardRadius};
    width: 100%;
    padding: 15px 30px;
    border: 1px solid ${theme.colors.xxlightGray};
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);

    & .row {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      border-bottom: 1px solid ${theme.colors.lightGray};
      padding-bottom: 25px;
      label {
        margin-top: 0;
      }
      select {
        margin-left: 10px;
      }
      span {
        display: flex;
        align-items: center;
        p {
          margin-left: 5px;
          font-family: ${theme.font.montserrat};
          font-weight: ${theme.font.normal};
        }
        .ml {
          margin-left: 10px;
        }
      }
      .service-type {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .input {
          width: 58%;
        }
      }
      .meta-data {
        width: 40%;
        display: flex;
        align-items: center;
      }
    }
    .actions-row {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }
  `}
`
export const ContainerCards = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-gap: 15px;
    grid-template-columns: calc(27% - 15px) calc(74% - 15px);
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 0px;
    margin-bottom: 20px;
    padding: 0 0px;

    > button {
      max-width: 228px;
      position: relative;

      > svg {
        position: absolute;
        left: 16px;
        top: 14px;

        > path {
          fill: ${theme.colors.white};
        }
      }
    }

    ${media.lessThan('medium')`
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      > button {
        max-width: 100%;
        margin: 0px 20px;
      }

      > div {
        margin: 18px 20px 0 20px;
      }
    `}
  `}
`
